import { render, staticRenderFns } from "./modalCancelandoExame.vue?vue&type=template&id=e2fc4862&"
import script from "./modalCancelandoExame.vue?vue&type=script&lang=js&"
export * from "./modalCancelandoExame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports